import { render, staticRenderFns } from "./AirportItem.vue?vue&type=template&id=d07116da&scoped=true"
import script from "./AirportItem.vue?vue&type=script&lang=js"
export * from "./AirportItem.vue?vue&type=script&lang=js"
import style0 from "./AirportItem.vue?vue&type=style&index=0&id=d07116da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07116da",
  null
  
)

export default component.exports